import React from "react";
import CommingSoon from "./CommingSoon";

export default function ReviewAnalytics() {
  return (
    <div>
      <CommingSoon title='서비스를 준비 중이에요.' lsDesc={[
        "사장님의 매장 운영에 도움을 드릴 수 있는",
        "분석 서비스를 위해 열심히 노력하고 있어요.",
        "기대해주세요!",        
      ]} />
    </div>
  );
}


